import { Controller as StimulusController } from '@hotwired/stimulus';

export const Controller = StimulusController;
export default StimulusController;
